import React from 'react';
import Wizard from "./wizard";

export default function AddApisAndEventSubs({
	visible, openFocusPane, filteredApis, scopeLastModified, projectIdEncrypted, ooid, aoid, consumerApplicationID,
	subscribedEvents, productCode, ...rest
}) {
	return (
		<>
			<Wizard
				open={visible}
				openWizardFn={openFocusPane}
				productCode={productCode}
				filteredApis={filteredApis}
				projectIdEncrypted={projectIdEncrypted}
				ooid={ooid}
				aoid={aoid}
				consumerApplicationID={consumerApplicationID}
				subscribedEvents={subscribedEvents}
				scopeLastModified={scopeLastModified}
				{...rest}
			/>
		</>
	);
};
